import { render, staticRenderFns } from "./host-set-projectset.vue?vue&type=template&id=871dcbf4&scoped=true&"
import script from "./host-set-projectset.vue?vue&type=script&lang=js&"
export * from "./host-set-projectset.vue?vue&type=script&lang=js&"
import style0 from "./host-set-projectset.vue?vue&type=style&index=0&id=871dcbf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871dcbf4",
  null
  
)

export default component.exports